import {Step} from './steps/step';
import {ErrorHandlingComponent} from '../error-handling.component';
import {ApplicationFlowNavigator} from './application-flow.navigator';

export abstract class AbstractApplicationFlowComponent extends ErrorHandlingComponent {
    protected readonly navigator: ApplicationFlowNavigator;

    constructor(navigator: ApplicationFlowNavigator) {
        super();
        this.navigator = navigator;
    }

    public async previousPage(): Promise<void> {
        await this.navigator.navigateToPrevious(this.step());
    }

    public abstract step(): new (...args: any[]) => Step;

    public async nextPage(): Promise<void> {
        await this.navigator.navigateToNext(this.step());
    }
}